import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { NOPING_GREEN } from '../constants';

const RED = '#EF4444';

const HIGH_PING_PATH = 'M0,15 L30,22 L55,10 L80,28 L105,14 L130,32 L155,18 L180,35 L205,20 L220,30';
const DROP_PATH = 'M220,30 C240,40 260,80 280,100 Q300,110 320,112 L360,111 L400,112 L440,111 L500,112';
const GREEN_FILL_PATH = 'M220,30 C240,40 260,80 280,100 Q300,110 320,112 L360,111 L400,112 L440,111 L500,112 L500,120 L220,120 Z';
const RED_FILL_PATH = 'M0,15 L30,22 L55,10 L80,28 L105,14 L130,32 L155,18 L180,35 L205,20 L220,30 L220,120 L0,120 Z';

export function HeroPingChart() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-30px' });

  return (
    <div ref={ref} className='relative mx-auto h-20 w-full max-w-md md:h-24'>
      <svg viewBox='0 0 500 120' className='size-full' preserveAspectRatio='none'>
        <defs>
          <linearGradient id='eu-dropFill' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor={NOPING_GREEN} stopOpacity='0.25' />
            <stop offset='100%' stopColor={NOPING_GREEN} stopOpacity='0' />
          </linearGradient>
          <linearGradient id='eu-redFill' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor={RED} stopOpacity='0.12' />
            <stop offset='100%' stopColor={RED} stopOpacity='0' />
          </linearGradient>
          <filter id='eu-pingGlow'>
            <feGaussianBlur stdDeviation='2' result='blur' />
            <feMerge>
              <feMergeNode in='blur' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
        </defs>

        {Array.from({ length: 5 }).map((_, i) => (
          <line key={i} x1='0' y1={24 * (i + 1)} x2='500' y2={24 * (i + 1)} stroke='#ffffff' strokeWidth='0.5' opacity='0.05' />
        ))}

        <motion.path d={RED_FILL_PATH} fill='url(#eu-redFill)' initial={{ opacity: 0 }} animate={inView ? { opacity: [0, 1, 1, 0] } : {}} transition={{ duration: 4, times: [0, 0.1, 0.6, 1], delay: 0.3 }} />

        <motion.path d={HIGH_PING_PATH} fill='none' stroke={RED} strokeWidth='2.5' initial={{ pathLength: 0, opacity: 0 }} animate={inView ? { pathLength: [0, 1, 1, 1], opacity: [0, 0.9, 0.9, 0] } : {}} transition={{ duration: 4, times: [0, 0.3, 0.6, 1] }} />

        <motion.text x='4' y='14' fill={RED} fontSize='9' fontFamily='monospace' fontWeight='bold' initial={{ opacity: 0 }} animate={inView ? { opacity: [0, 0.8, 0.8, 0] } : {}} transition={{ duration: 4, times: [0, 0.15, 0.6, 1] }}>
          150ms
        </motion.text>

        <motion.line x1='220' y1='0' x2='220' y2='120' stroke={NOPING_GREEN} strokeWidth='1.5' strokeDasharray='3 3' initial={{ opacity: 0 }} animate={inView ? { opacity: [0, 0.5, 0.5, 0] } : {}} transition={{ duration: 4, times: [0, 0.25, 0.6, 1] }} />
        <motion.text x='226' y='116' fill={NOPING_GREEN} fontSize='8' fontFamily='monospace' initial={{ opacity: 0 }} animate={inView ? { opacity: [0, 0.7, 0.7, 0] } : {}} transition={{ duration: 4, times: [0, 0.25, 0.6, 1] }}>
          NoPing ON
        </motion.text>

        <motion.path d={DROP_PATH} fill='none' stroke={NOPING_GREEN} strokeWidth='2.5' filter='url(#eu-pingGlow)' initial={{ pathLength: 0, opacity: 0 }} animate={inView ? { pathLength: 1, opacity: 1 } : {}} transition={{ duration: 1.8, delay: 1.0, ease: 'easeOut' }} />

        <motion.path d={GREEN_FILL_PATH} fill='url(#eu-dropFill)' initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}} transition={{ duration: 0.8, delay: 2.2 }} />

        <motion.text x='450' y='108' fill={NOPING_GREEN} fontSize='9' fontFamily='monospace' fontWeight='bold' initial={{ opacity: 0 }} animate={inView ? { opacity: 0.9 } : {}} transition={{ duration: 0.3, delay: 2.5 }}>
          2-5ms
        </motion.text>
      </svg>
    </div>
  );
}
